// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import { baseIcon, defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
import { isWaffle, isWhiteLabel } from '@bubble-ui/particle-design-versions';
var IconCreditCardPathPancake = 'M17 2H3C1.346 2 0 3.346 0 5v10c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3Zm1 13c0 .551-.449 1-1 1H3c-.551 0-1-.449-1-1V9h16v6ZM17 4H3c-.551 0-1 .449-1 1v1h16V5c0-.551-.449-1-1-1Zm-1 8.5a1.5 1.5 0 1 1-2.999.001A1.5 1.5 0 0 1 16 12.5Zm-3 0a1.5 1.5 0 1 0-2.999-.001A1.5 1.5 0 0 0 13 12.5Z';
var IconCreditCardPathWaffle = 'M16.667 3H3.333A3.337 3.337 0 0 0 0 6.333v7.5a3.337 3.337 0 0 0 3.333 3.334h13.334A3.337 3.337 0 0 0 20 13.833v-7.5A3.337 3.337 0 0 0 16.667 3ZM3.333 4.667h13.334c.918 0 1.666.747 1.666 1.666v.834H1.667v-.834c0-.919.748-1.666 1.666-1.666ZM16.667 15.5H3.333a1.669 1.669 0 0 1-1.666-1.667v-5h16.666v5c0 .92-.748 1.667-1.666 1.667ZM3.333 11.333H7.5V13H3.333v-1.667Z';
var IconCreditCardPathWaffleFilled = 'M16.667 3H3.333A3.332 3.332 0 0 0 0 6.333v.834h20v-.834A3.332 3.332 0 0 0 16.667 3ZM0 8.833v5a3.332 3.332 0 0 0 3.333 3.334h13.334A3.332 3.332 0 0 0 20 13.833v-5H0ZM7.5 13H3.333v-1.667H7.5V13Z';
var IconCreditCardPathWhiteLabel = 'M17.663 15.656c.337-.342.506-.747.506-1.216V5.56c0-.47-.169-.875-.506-1.217a1.655 1.655 0 0 0-1.224-.513H3.56a1.66 1.66 0 0 0-1.216.513 1.662 1.662 0 0 0-.513 1.216v8.88c0 .47.17.875.513 1.217a1.66 1.66 0 0 0 1.216.513h12.88c.48 0 .887-.171 1.224-.513ZM16.44 6.984H3.56V5.56h12.88v1.425ZM3.56 14.44V9.984h12.88v4.456H3.56Z';
var IconCreditCardPathWhiteLabelFilled = 'M3.56 16.169a1.66 1.66 0 0 1-1.217-.513 1.662 1.662 0 0 1-.513-1.216V5.56c0-.47.17-.875.513-1.217a1.662 1.662 0 0 1 1.216-.513h12.88c.484 0 .893.171 1.227.513.335.342.503.747.503 1.216v8.88c0 .47-.168.875-.503 1.217a1.652 1.652 0 0 1-1.227.513H3.56Zm0-6.185h12.88v-3H3.56v3Z';
var IconCreditCardViewBoxWaffle = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconCreditCardViewBoxWaffleFilled = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconCreditCardViewBoxWhiteLabel = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
var IconCreditCardViewBoxWhiteLabelFilled = {
  viewBoxWidth: 20,
  viewBoxHeight: 20
};
export var IconCreditCard = baseIcon('IconCreditCard', {
  groupProps: defaultIconGroupProps,
  getPath: _ref => {
    var {
      designVersion,
      filled
    } = _ref;
    return isWhiteLabel(designVersion) ? filled ? IconCreditCardPathWhiteLabelFilled : IconCreditCardPathWhiteLabel : isWaffle(designVersion) ? filled ? IconCreditCardPathWaffleFilled : IconCreditCardPathWaffle : IconCreditCardPathPancake;
  },
  shapeSize: _ref2 => {
    var {
      designVersion,
      filled
    } = _ref2;
    return isWhiteLabel(designVersion) ? filled ? IconCreditCardViewBoxWhiteLabelFilled : IconCreditCardViewBoxWhiteLabel : isWaffle(designVersion) ? filled ? IconCreditCardViewBoxWaffleFilled : IconCreditCardViewBoxWaffle : {};
  }
});
//# sourceMappingURL=index.js.map